import React, { useState } from 'react';

import { ia } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import AdjustmentRow from './components/AdjustmentRow';

const Adjustments = ({ procedure = {}, payerOrder = '', setClaim = () => {}, procedureIndex }) => {
  const [primaryErrors, setPrimaryErrors] = useState({
    paidError: false,
    dateError: false
  });

  const [secondaryErrors, setSecondaryErrors] = useState({
    paidError: false,
    dateError: false
  });

  const mergeAdjustmentArrays = (adjustment) => {
    const insAdj = ia(adjustment?.ins_adj) ? adjustment.ins_adj : [];
    const ptAdj = ia(adjustment?.pt_adj) ? adjustment.pt_adj : [];
    return [...insAdj, ...ptAdj];
  };

  const lastPrimaryAdjustment =
    ia(procedure?.primary) && procedure?.primary[procedure?.primary?.length - 1 || 0];
  const mergedPrimaryAdjustments = mergeAdjustmentArrays(lastPrimaryAdjustment);
  const mergedPrimaryAdjustment = {
    ...lastPrimaryAdjustment,
    ins_adj: mergedPrimaryAdjustments
  };

  const lastSecondaryAdjustment =
    ia(procedure?.secondary) && procedure?.secondary[procedure?.secondary?.length - 1 || 0];
  const mergedSecondaryAdjustments = mergeAdjustmentArrays(lastSecondaryAdjustment);
  const mergedSecondaryAdjustment = {
    ...lastSecondaryAdjustment,
    ins_adj: mergedSecondaryAdjustments
  };

  return (
    <tr>
      <td colSpan="10" className="!px-0 align-bottom">
        <div className="flex flex-col">
          {(payerOrder?.toLowerCase() === 'secondary' ||
            payerOrder?.toLowerCase() === 'tertiary') && (
            <>
              <AdjustmentRow
                insType="primary"
                lastAdjustment={mergedPrimaryAdjustment}
                errors={primaryErrors}
                setErrors={setPrimaryErrors}
                procedureIndex={procedureIndex}
                setClaim={setClaim}
              />
              {payerOrder?.toLowerCase() === 'tertiary' && (
                <>
                  <AdjustmentRow
                    insType="secondary"
                    lastAdjustment={mergedSecondaryAdjustment}
                    errors={secondaryErrors}
                    setErrors={setSecondaryErrors}
                    procedureIndex={procedureIndex}
                    setClaim={setClaim}
                  />
                </>
              )}
            </>
          )}
        </div>
      </td>
    </tr>
  );
};

export default withErrorBoundary(Adjustments);
